<script setup lang="ts">
import { createError, useRoute } from '#app';
import { spotlightCategoryBySlug } from '@/lib/spotlight-taxonomy';
import SpotlightIndexPage from '../index.vue';

const route = useRoute();
const rawCategory = Array.isArray(route.params.category)
  ? route.params.category[0]
  : route.params.category;
const category = spotlightCategoryBySlug(rawCategory);

if (!category) {
  throw createError({ statusCode: 404, statusMessage: 'Spotlight category not found' });
}
</script>

<template>
  <SpotlightIndexPage :category="category.value" />
</template>
